export const validateDate = (date: string | Date): boolean => {
  // date cannot be a single number
  if (typeof date === "string" && !isNaN(Number(date))) return false;
  const d = new Date(date);
  return d instanceof Date && !isNaN(d.getTime());
};
